import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
    {
        id: "po-06-h5v1-01",
        name: "PO 01 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 41, y: 169, width: 387, height: 579, rotation: 0, imageRotation: 0 },
            { id: "2", x: 436, y: 169, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 316, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 436, y: 463, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 436, y: 610, width: 213, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 736, y: 259, width: 589, height: 399, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-02",
        name: "PO 02 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 61, y: 255, width: 269, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 255, width: 300, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 338, y: 462, width: 300, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 743, y: 174, width: 561, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 743, y: 556, width: 277, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 556, width: 277, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-03",
        name: "PO 03 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 259, width: 589, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 725, y: 169, width: 387, height: 579, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1120, y: 169, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1120, y: 316, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1120, y: 463, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1120, y: 610, width: 213, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-04",
        name: "PO 04 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 98, y: 124, width: 496, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 458, width: 244, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 98, y: 629, width: 244, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 350, y: 458, width: 244, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 350, y: 629, width: 244, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 806, y: 124, width: 449, height: 668, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-05",
        name: "PO 05 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 272, width: 557, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 761, y: 602, width: 174, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 943, y: 602, width: 357, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 71, width: 539, height: 336, rotation: 0, imageRotation: 0 },
            { id: "5", x: 761, y: 415, width: 266, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 415, width: 266, height: 179, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-06",
        name: "PO 06 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 273, width: 274, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 282, y: 273, width: 274, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 462, width: 274, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 282, y: 462, width: 274, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 563, y: 273, width: 249, height: 370, rotation: 0, imageRotation: 0 },
            { id: "6", x: 819, y: 273, width: 555, height: 370, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-07",
        name: "PO 07 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 194, width: 350, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 357, y: 194, width: 204, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 357, y: 329, width: 204, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 357, y: 463, width: 204, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 357, y: 597, width: 204, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 569, y: 194, width: 807, height: 529, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-08",
        name: "PO 08 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 580, width: 287, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 151, width: 287, height: 421, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 151, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 365, y: 462, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "5", x: 839, y: 151, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "6", x: 839, y: 462, width: 466, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-09",
        name: "PO 09 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 154, width: 236, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 313, y: 154, width: 492, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 813, y: 154, width: 492, height: 330, rotation: 0, imageRotation: 0 },
            { id: "4", x: 70, y: 492, width: 407, height: 271, rotation: 0, imageRotation: 0 },
            { id: "5", x: 485, y: 492, width: 406, height: 271, rotation: 0, imageRotation: 0 },
            { id: "6", x: 899, y: 492, width: 406, height: 271, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h5v1-10",
        name: "PO 10 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 88, y: 129, width: 319, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 351, width: 319, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 88, y: 573, width: 319, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 414, y: 129, width: 444, height: 658, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 129, width: 443, height: 325, rotation: 0, imageRotation: 0 },
            { id: "6", x: 865, y: 462, width: 443, height: 325, rotation: 0, imageRotation: 0 }
        ],
    },
];

